export const V2_SIGNUP_PAGE = 'onboarding/V2_SIGNUP_PAGE'
export const V2_COMPANY_PAGE = 'onboarding/V2_COMPANY_PAGE'
export const V2_OWNER_PAGE = 'onboarding/V2_OWNER_PAGE'
export const V2_PASSWORD_PAGE = 'onboarding/V2_PASSWORD_PAGE'
export const V2_VERIFICATION_PAGE = 'onboarding/V2_VERIFICATION_PAGE'
export const V2_COMPLETION_PAGE = 'onboarding/V2_COMPLETION_PAGE'
